import React from "react"
import useReize from "../../../helpers/useResize"
import { Logo } from "../HeaderStyles"

export default function Title({ settings }: any) {
  const { isMobile } = useReize()
  return (
    <>
      {(isMobile || window.innerWidth < 768) &&
      settings.settingsSubpage !== "" ? (
        <span
          style={{
            pointerEvents: "none",
            lineHeight: 1,
          }}
        >
          {settings.settingsSubpage === "Game_Rules"
            ? "STELLAR RULES"
            : settings.settingsSubpage}
        </span>
      ) : (
        <Logo>
          <p>st</p>ellar
        </Logo>
      )}
    </>
  )
}
